<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
		<path
			:fill="color"
			d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m-48-247.616L668.608 512 464 375.616zm10.624-342.656 249.472 166.336a48 48 0 0 1 0 79.872L474.624 718.272A48 48 0 0 1 400 678.336V345.6a48 48 0 0 1 74.624-39.936z"
		></path>
	</svg>
</template>

<script>
export default {
	name: 'VideoIcon',
	props: {
		color: {
			type: String,
			default: 'var(--el-color-primary)',
		},
	},
};
</script>
